import script from "./AddInvoiceForExpense.vue?vue&type=script&setup=true&lang=ts"
export * from "./AddInvoiceForExpense.vue?vue&type=script&setup=true&lang=ts"

import "./AddInvoiceForExpense.vue?vue&type=style&index=0&id=0d7c8ae0&lang=scss&scoped=true"

import exportComponent from "/fides/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0d7c8ae0"]])

export default __exports__